export default function industryVideo() {
	if ($('.industry-video-modal').length) {
    // open modal
    $('.industry-video__preview').click(function() {
      let thisModalID = $(this).data('modal'),
          thisModal = $(thisModalID);

      thisModal.toggleClass('active');
    });
    // close modal
    $('.industry-video-modal .close').click(function() {
      $(this).closest('.industry-video-modal').toggleClass('active');
    });
  }
};